import React from "react";

export default function HistoryMobileCard({ title, time, badge, author, reason, fields }) {
  return (
    <article className="min-w-0 rounded-2xl border border-slate-200 bg-white p-4 text-sm dark:border-white/10 dark:bg-white/5">
      <div className="flex flex-wrap items-start justify-between gap-2">
        <h2 className="min-w-0 flex-1 basis-40 break-words font-semibold text-slate-900 dark:text-white">{title}</h2>
        <span className="max-w-full break-words rounded-lg bg-amber-100 px-2 py-1 font-semibold text-amber-800 dark:bg-amber-300/10 dark:text-amber-200">{badge}</span>
      </div>
      <p className="mt-2 break-words text-xs text-slate-500 dark:text-white/60">{time ? new Date(time).toLocaleString("fr-FR") : "Date non renseignée"}</p>
      <p className="mt-3 break-words text-slate-700 dark:text-white/80"><span className="text-slate-500 dark:text-white/60">Auteur : </span>{author}</p>
      <p className="mt-1 break-words text-slate-700 dark:text-white/80"><span className="text-slate-500 dark:text-white/60">Motif : </span>{reason}</p>
      <details className="mt-3 border-t border-slate-200 pt-2 dark:border-white/10">
        <summary className="cursor-pointer rounded-lg py-2 font-medium text-slate-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-amber-400 dark:text-white/80">Voir les détails</summary>
        <dl className="mt-2 space-y-3">
          {fields.map(([label, value]) => (
            <div key={label}>
              <dt className="text-xs text-slate-500 dark:text-white/60">{label}</dt>
              <dd className="mt-1 break-words font-medium text-slate-800 dark:text-white">{value || "—"}</dd>
            </div>
          ))}
        </dl>
      </details>
    </article>
  );
}
